import { createFileRoute, Navigate } from '@tanstack/react-router';
import { orgRoute } from '@/app/org-route';

// Old /admin/groups deep links redirect into the consolidated
// Settings page. Keep the route so external bookmarks don't 404.
export const Route = createFileRoute('/$orgId/admin/groups')({
  component: () => (
    <Navigate to={orgRoute('/settings')} search={{ section: 'groups' }} replace />
  ),
});
